import { render, staticRenderFns } from "./parentinformation.vue?vue&type=template&id=71ae1be6&scoped=true"
import script from "./parentinformation.vue?vue&type=script&lang=js"
export * from "./parentinformation.vue?vue&type=script&lang=js"
import style0 from "./parentinformation.vue?vue&type=style&index=0&id=71ae1be6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ae1be6",
  null
  
)

export default component.exports